module.exports = __webpack_public_path__ + "static/media/foto3.bfb4819a.png";